import React from "react";
import Box, { BoxProps } from "@mui/material/Box";
import { EmtTypography } from "./EmtTypography";
import { EmtRadio } from "./EmtRadio";
import { styled } from "@mui/material/styles";
import Skeleton from "@mui/material/Skeleton";

export type EmtSelectBoxProps = BoxProps & {
  /**
   * Set if SelectBox is active or note.
   * If true, the radio button is checked
   * @default false
   */
  active?: boolean;
  /**
   * Left text on the box
   * It has to be a string, no react component here
   * @default undefined
   */
  title?: string;
  /**
   * Right content of the box
   * Can be react node
   * @default undefined
   */
  children?: React.ReactNode;
  /**
   * Pulsate loader
   * @default false
   */
  loader?: boolean;
  nonce?: string;
};

const SelectBox = styled(Box)((props) => {
  const { theme }: { theme: any } = props;
  return {
    padding: "15px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderRadius: "18px",
    cursor: "pointer",
    background: theme.palette.common.white,
    border: "1px solid transparent",
    "&.active": {
      border: `1px solid ${theme.palette.primary.main}`,
    },
    "&.purple": {
      border: `1px solid ${(theme.palette as any).purple[600]}`,
    },
  };
});

const RadioContainer = styled(Box)(() => ({
  display: "flex",
  gap: "10px",
  alignItems: "center",
}));

export function EmtSelectBox(props: EmtSelectBoxProps) {
  const { title, children, active = false, loader = false, ...rest } = props;

  return loader ? (
    <Skeleton
      variant="rectangular"
      width={"100%"}
      height={100}
      sx={{ borderRadius: "18px" }}
    />
  ) : (
    <SelectBox className={active ? "active" : ""} {...rest}>
      <RadioContainer>
        {/* @ts-ignore */}
        <EmtRadio color="greyGradient" checked={active} />
        <EmtTypography variant="body2" fontWeight="bold">
          {title}
        </EmtTypography>
      </RadioContainer>

      <Box>{children}</Box>
    </SelectBox>
  );
}
